<template functional>
    <div v-bind="data.attrs" :class="[data.staticClass, data.class]">
        <label v-if="props.label === ''" :class="props.labelClass">{{ props.field.label }}:</label>
        <label v-else :class="props.labelClass">{{ props.label }}:</label>
        <slot><span :class="props.valueClass" class="">{{ props.value | valueOrEmpty }}</span></slot>
        <slot name="help-text">
            <span
                v-if="!props.noHelpText && props.field.help_text"
                :class="props.helpTextClass"
            >
            {{ props.field.help_text }}
            </span>
        </slot>

        <slot name="after-value"></slot>
    </div>
</template>

<script>
    export default {
        name: "DisplayField",
        props: {
            field: {
                type: Object,
                required: true,
            },
            value: {
                type: null,
            },
            label: {
                type: String,
                default: ''
            },
            noInline: {
                type: Boolean,
                default: false
            },
            labelClass: {
                type: String,
                default: '',
            },
            valueClass: {
                type: String,
                default: '',
            },
            helpTextClass: {
                type: String,
                default: '',
            },
            noHelpText: {
                type: Boolean,
                default: false,
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import "src/custom";

    label {
        @extend .form-label;
        @extend .mr-1;
    }
</style>